/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-22 08:07:25
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, getFormValues, change } from 'redux-form';
import { FormLayout } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { RenderTextField } from 'src/components/views/common/forms/render-textfield';
import { RenderCheckbox } from 'src/components/views/common/forms/render-checkbox';
import { hasTag } from 'src/helpers/form-validation-helper';

type Props = WithI18nProps;
// DONE
class StockStatus extends Component<Props, State> {
  state = {
    inStockStatus: false,
    outOfStockStatus: false
  };

  componentDidMount() {
    const { stockStatusInStock, stockStatusOutOfStock } = this.props;
    this.setState({ inStockStatus: stockStatusInStock, outOfStockStatus: stockStatusOutOfStock });
  }

  componentWillReceiveProps(nextProps) {
    const { stockStatusInStock, stockStatusOutOfStock } = nextProps;
    const { updateFilterOption } = this.props;

    // Empty in stock label if in status status is disabled
    if (!stockStatusInStock) {
      updateFilterOption('stockStatusInStockLabel', '');
    }

    // Set default value for in stock label
    if (!this.props.stockStatusInStock && stockStatusInStock) {
      updateFilterOption('stockStatusInStockLabel', 'In Stock');
    }

    // Empty out stock label if in status status is disabled
    if (!stockStatusOutOfStock) {
      updateFilterOption('stockStatusOutOfStockLabel', '');
    }

    // Set default value for out of stock label
    if (!this.props.stockStatusOutOfStock && stockStatusOutOfStock) {
      updateFilterOption('stockStatusOutOfStockLabel', 'Out of Stock');
    }
  }

  render() {
    const { inStockStatus, outOfStockStatus } = this.state;
    const { i18n } = this.props;

    return (
      <FormLayout>
        <div className="checkboxWithTextfield">
          <div className="checkbox">
            <Field
              name="stockStatusInStock"
              component={RenderCheckbox}
              label={i18n.translate(
                'AdminHTML.FilterTree.Item.optionModal_GeneralTab_StockStatus_Field1_Label'
              )}
              checked={inStockStatus}
              onChange={() => this.handleChangeCheckbox('stockStatusInStock')}
            />
          </div>
          <div className="textfield">
            <Field name="stockStatusInStockLabel" component={RenderTextField} validate={[hasTag]} />
          </div>
        </div>

        <div className="checkboxWithTextfield">
          <div className="checkbox">
            <Field
              name="stockStatusOutOfStock"
              component={RenderCheckbox}
              label={i18n.translate(
                'AdminHTML.FilterTree.Item.optionModal_GeneralTab_StockStatus_Field2_Label'
              )}
              checked={outOfStockStatus}
              onChange={() => this.handleChangeCheckbox('stockStatusOutOfStock')}
            />
          </div>
          <div className="textfield">
            <Field
              name="stockStatusOutOfStockLabel"
              component={RenderTextField}
              validate={[hasTag]}
            />
          </div>
        </div>
      </FormLayout>
    );
  }

  // Handle check box change
  handleChangeCheckbox = name => {
    if (name === 'stockStatusInStock') {
      this.setState(({ inStockStatus }) => ({ inStockStatus: !inStockStatus }));
    } else {
      this.setState(({ outOfStockStatus }) => ({ outOfStockStatus: !outOfStockStatus }));
    }
  };
}

const mapStateToProps = (state, props) => {
  const formFilterOptionValues = getFormValues('OptionModalForm')(state);

  return {
    optionType: _.get(formFilterOptionValues, 'optionType', ''),
    stockStatusInStock: _.get(formFilterOptionValues, 'stockStatusInStock', false),
    stockStatusOutOfStock: _.get(formFilterOptionValues, 'stockStatusOutOfStock', false)
  };
};

const mapDispatchToProps = dispatch => ({
  updateFilterOption: (field, value) => dispatch(change(`OptionModalForm`, field, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(StockStatus));
